import { render, staticRenderFns } from "./SpaceHelpPage.vue?vue&type=template&id=78a1657a&scoped=true"
import script from "./SpaceHelpPage.vue?vue&type=script&lang=js"
export * from "./SpaceHelpPage.vue?vue&type=script&lang=js"
import style0 from "./SpaceHelpPage.vue?vue&type=style&index=0&id=78a1657a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1657a",
  null
  
)

export default component.exports